<div class="tooltip-wrapper">
  <div id="target-{{id}}" #targetRef class="tooltip-target">
    <ng-content> </ng-content>
  </div>
  <div id="tooltip-{{id}}" #tooltipRef class="tooltip-tooltip">
    <ng-content select="[tooltip]"> </ng-content>
  </div>
</div>
